import { combineReducers } from 'redux';
// Store thật được tạo ở src/index.tsx từ file này. Danh sách reducer khai báo DUY NHẤT ở
// store/slices/index.ts (cũng là nguồn của RootState) — từng chép tay hai nơi và quên `inbox`
// → state.inbox undefined, trang Hộp thư crash.
import slices from '@app/store/slices';

export default combineReducers(slices);
